import React, { useEffect, useState } from "react";
import { DialogActions } from "@material-ui/core";
import { FieldArray, useFormikContext } from "formik";
import { TabView, TabPanel } from "primereact/tabview";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import Illustration from "../../../../../partials/content/Illustration";
import SearchCustomer from "../../../sales/customers/searchCustomer";
import SearchLead from "../../leads/searchLead";
import SearchSalesCard from "../../slc/searchSalesCard";
import VisitActivities from "./visitActivities";
import { Table } from "react-bootstrap";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import {
  FormArrayTextField,
  FormArrayDateField,
} from "../../../../../partials/content/Forms/FormField";
import { DateTime } from "luxon";
import { isMobile } from "react-device-detect";
const JourneyVisitForm = ({ journeyID = 0, arrayName }) => {
  const [openSearchVisitTo, setOpenSearchVisitTo] = useState(false);
  const [openSearchSalesCard, setOpenSearchSalesCard] = useState(false);
  const [openPlanActivities, setOpenPlanActivities] = useState(false);
  const [selectedVisitIndex, setSelectedVisitIndex] = useState(0);
  const [planActivities, setPlanActivities] = useState([]);
  const { values, setFieldValue } = useFormikContext();
  useEffect(() => {}, []);
  return (
    <React.Fragment>
      <FieldArray name={arrayName}>
        {({ push, remove }) => (
          <React.Fragment>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                {!isMobile ? (
                  <div className="card">
                    <Table borderless size="sm" responsive="xl">
                      {values[arrayName] && values[arrayName].length > 0 ? (
                        <thead className="text-center">
                          <tr>
                            <th style={{ width: "35%" }}>Visit To</th>
                            <th style={{ width: "35%" }}>Sales Card Name</th>
                            <th style={{ width: "25%" }}>Plan Visit Date</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                      ) : null}
                      <tbody>
                        {values[arrayName] && values[arrayName].length > 0 ? (
                          values[arrayName].map((item, index) => (
                            <tr key={index}>
                              <td>
                                <FormArrayTextField
                                  arrayPropName={arrayName}
                                  index={index}
                                  propName="visitTo"
                                  margin="none"
                                  readonly
                                  searchButton
                                  onSearchClick={() => {
                                    setSelectedVisitIndex(index);
                                    setOpenSearchVisitTo(true);
                                  }}
                                />
                              </td>
                              <td>
                                <FormArrayTextField
                                  arrayPropName={arrayName}
                                  index={index}
                                  propName="salesCardTitle"
                                  margin="none"
                                  readonly
                                  searchButton
                                  clearButton
                                  onClearFields={() => {
                                    setFieldValue(
                                      `${arrayName}[${index}].salesCardID`,
                                      0
                                    );
                                    setFieldValue(
                                      `${arrayName}[${index}].salesCardTitle`,
                                      ""
                                    );
                                  }}
                                  onSearchClick={() => {
                                    setSelectedVisitIndex(index);
                                    setOpenSearchSalesCard(true);
                                  }}
                                />
                              </td>
                              <td>
                                <FormArrayDateField
                                  arrayPropName={arrayName}
                                  index={index}
                                  propName="planVisitDate"
                                />
                              </td>
                              <td
                                style={{ whiteSpace: "nowrap" }}
                                className="text-center"
                              >
                                {index > 0 ? (
                                  <BootstrapTooltip title="Delete Visit Item">
                                    <button
                                      type="button"
                                      className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                      onClick={() => {
                                        remove(index);
                                      }}
                                    >
                                      <i className="fas fa-trash-alt"></i>
                                    </button>
                                  </BootstrapTooltip>
                                ) : null}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center py-3" colSpan="4">
                              <Illustration
                                imageSource="INVIFO CRM.png"
                                guidance="You don't have any Journey Visit items yet"
                                guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                size="sm"
                              ></Illustration>
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td className="text-center py-3" colSpan="4">
                            <button
                              type="button"
                              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                              onClick={() => {
                                push({
                                  ID: 0,
                                  journeyID,
                                  visitType: 1,
                                  statusID: 1,
                                  visitTo: "",
                                  customerID: 0,
                                  leadID: 0,
                                  salesCardID: 0,
                                  salesCardTitle: "",
                                  planVisitDate: DateTime.now().endOf("day"),
                                  title: "",
                                  description: "",
                                });
                              }}
                            >
                              <i className="fas fa-plus-circle"></i>
                              Add Visit
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <React.Fragment>
                    <button
                      type="button"
                      className="btn btn-md btn-success"
                      style={{ width: "100%" }}
                      onClick={() => {
                        push({
                          ID: 0,
                          journeyID,
                          visitType: 1,
                          statusID: 1,
                          visitTo: "",
                          customerID: 0,
                          leadID: 0,
                          salesCardID: 0,
                          salesCardTitle: "",
                          planVisitDate: DateTime.now().endOf("day"),
                          title: "",
                          description: "",
                        });
                      }}
                    >
                      Add Visit
                    </button>
                    <br /> <br />
                    {values[arrayName] && values[arrayName].length > 0
                      ? values[arrayName].map((item, index) => (
                          <React.Fragment key={index}>
                            <div className="card">
                              <FormArrayTextField
                                arrayPropName={arrayName}
                                index={index}
                                propName="visitTo"
                                margin="none"
                                readonly
                                searchButton
                                onSearchClick={() => {
                                  setSelectedVisitIndex(index);
                                  setOpenSearchVisitTo(true);
                                }}
                              />
                              <FormArrayTextField
                                arrayPropName={arrayName}
                                index={index}
                                propName="salesCardTitle"
                                margin="none"
                                readonly
                                searchButton
                                clearButton
                                onClearFields={() => {
                                  setFieldValue(
                                    `${arrayName}[${index}].salesCardID`,
                                    0
                                  );
                                  setFieldValue(
                                    `${arrayName}[${index}].salesCardTitle`,
                                    ""
                                  );
                                }}
                                onSearchClick={() => {
                                  setSelectedVisitIndex(index);
                                  setOpenSearchSalesCard(true);
                                }}
                              />
                              <FormArrayDateField
                                arrayPropName={arrayName}
                                index={index}
                                propName="planVisitDate"
                              />
                            </div>
                            {index > 0 ? (
                              <BootstrapTooltip title="Delete Visit Item">
                                <button
                                  type="button"
                                  className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                  onClick={() => {
                                    remove(index);
                                  }}
                                >
                                  <i className="fas fa-trash-alt"></i>
                                </button>
                              </BootstrapTooltip>
                            ) : null}
                            <br />
                            <br />
                          </React.Fragment>
                        ))
                      : null}
                  </React.Fragment>
                )}
              </div>
            </div>
          </React.Fragment>
        )}
      </FieldArray>
      <DialogLayout
        open={openPlanActivities}
        title="Plan Activities"
        onCloseDialog={handleClosePlanActivities}
        fullScreen={false}
      >
        <VisitActivities
          activities={planActivities}
          onCloseDialog={handleClosePlanActivities}
          onConfirmSave={(activities) => {
            setFieldValue(
              `visits[${selectedVisitIndex}].visitActivities`,
              activities
            );
            handleClosePlanActivities();
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openSearchVisitTo}
        title="Search Visit To"
        onCloseDialog={handleCloseSearchVisitTo}
        maxWIdth="lg"
      >
        <div className="tabview">
          <div className="card">
            <TabView className="tabview" scrollable>
              <TabPanel header="Customers" rightIcon="fas fa-user-tag">
                <SearchCustomer
                  onSelectCustomer={(customer) => {
                    const visitTmp = {
                      ...values[arrayName][selectedVisitIndex],
                    };
                    visitTmp.customerID = customer.ID;
                    visitTmp.leadID = 0;
                    visitTmp.visitTo = customer.customerName;
                    visitTmp.salesCardID = 0;
                    visitTmp.salesCardTitle = "";
                    setFieldValue(
                      `${arrayName}[${selectedVisitIndex}]`,
                      visitTmp
                    );
                    handleCloseSearchVisitTo();
                  }}
                />
              </TabPanel>
              <TabPanel header="Leads" rightIcon="fas fa-user-check">
                <SearchLead
                  onSelectLead={(lead) => {
                    const visitTmp = {
                      ...values[arrayName][selectedVisitIndex],
                    };
                    visitTmp.leadID = lead.ID;
                    visitTmp.customerID = 0;
                    visitTmp.visitTo = lead.leadName;
                    setFieldValue(
                      `${arrayName}[${selectedVisitIndex}]`,
                      visitTmp
                    );
                    handleCloseSearchVisitTo();
                  }}
                />
              </TabPanel>
            </TabView>
          </div>
        </div>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseSearchVisitTo}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchSalesCard}
        title="Search Sales Card"
        onCloseDialog={handleCloseSearchSalesCard}
        maxWIdth="lg"
      >
        <SearchSalesCard
          onSelectSalesCard={(salesCard) => {
            const visitTmp = { ...values[arrayName][selectedVisitIndex] };
            visitTmp.salesCardID = salesCard.ID;
            visitTmp.salesCardTitle = salesCard.title;
            if (salesCard.customer.ID > 0) {
              visitTmp.customerID = salesCard.customer.ID;
              visitTmp.leadID = 0;
              visitTmp.visitTo = salesCard.customer.customerName;
            } else if (salesCard.lead.ID > 0) {
              visitTmp.leadID = salesCard.lead.ID;
              visitTmp.customerID = 0;
              visitTmp.visitTo = salesCard.lead.leadName;
            }
            setFieldValue(`${arrayName}[${selectedVisitIndex}]`, visitTmp);
            handleCloseSearchSalesCard();
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseSearchSalesCard}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  function handleClosePlanActivities() {
    setOpenPlanActivities(false);
  }

  function handleCloseSearchVisitTo() {
    setOpenSearchVisitTo(false);
  }

  function handleCloseSearchSalesCard() {
    setOpenSearchSalesCard(false);
  }
};

export default JourneyVisitForm;
